// extracted by mini-css-extract-plugin
export const cookiesBar__container = "cookiesBar-module--cookiesBar__container--YTSYZ";
export const cookiesBarSlideIn = "cookiesBar-module--cookiesBarSlideIn--294_q";
export const cookiesBar__content = "cookiesBar-module--cookiesBar__content--1XeU5";
export const cookiesBar__icon = "cookiesBar-module--cookiesBar__icon--255dK";
export const cookiesBar__button = "cookiesBar-module--cookiesBar__button--3BfZh";
export const cookiesBar__link = "cookiesBar-module--cookiesBar__link--13rLT";